import { FolderIcon, HouseholdIcon, TagIcon, UserIcon } from "@hightouch/htui";
import * as React from "react";
import {
  CatalogIcon,
  EventIcon,
  ParentIcon,
  RelatedIcon,
  LightningIcon,
  AdStatsIcon,
  AssetIcon,
  MessageEventIcon,
} from "src/pages/schema/icons";
import type { SchemaIconProps } from "src/pages/schema/icons/types";
import { SchemaModelType } from "src/types/schema";
import { ModelSemanticType } from "src/types/visual";

export const SchemaLabelColumns = [
  { label: "People", value: ModelSemanticType.People, icon: UserIcon },
  {
    label: "Households",
    value: ModelSemanticType.Households,
    icon: HouseholdIcon,
  },
  { label: "Accounts", value: ModelSemanticType.Accounts, icon: FolderIcon },
  { label: "Coupons", value: ModelSemanticType.Coupons, icon: TagIcon },
];

export const SemanticTypeIcons: Record<ModelSemanticType, typeof UserIcon> = {
  [ModelSemanticType.People]: UserIcon,
  [ModelSemanticType.Households]: HouseholdIcon,
  [ModelSemanticType.Accounts]: FolderIcon,
  [ModelSemanticType.Coupons]: TagIcon,
};

export const schemaIcons: Record<SchemaModelType, React.FC<SchemaIconProps>> = {
  [SchemaModelType.Parent]: ParentIcon,
  [SchemaModelType.Event]: EventIcon,
  [SchemaModelType.RealtimeEvent]: LightningIcon,
  [SchemaModelType.Interaction]: EventIcon,
  [SchemaModelType.Related]: RelatedIcon,
  [SchemaModelType.Catalog]: CatalogIcon,
  [SchemaModelType.Group]: RelatedIcon,
  [SchemaModelType.Asset]: AssetIcon,
  [SchemaModelType.AdStats]: AdStatsIcon,
  [SchemaModelType.MessageEvent]: MessageEventIcon,
  [SchemaModelType.General]: ParentIcon,
};
